import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import type { UiBaseProps } from "../uiProps.utils";

export enum ModalWidth {
  XS = "xs",
  SM = "sm",
  MD = "md",
  LG = "lg",
  XL = "xl",
}

export type ModalProps = UiBaseProps & {
  open: boolean;
  // Called on a backdrop click or Escape; leave it out to keep the modal open, e.g. while saving.
  onClose?: () => void;
  fullScreen?: boolean;
  fullWidth?: boolean;
  maxWidth?: ModalWidth;
  // Styles the window itself (background, height, corners), not the dimmed backdrop.
  surfaceStyle?: React.CSSProperties;
  // Styles the dimmed layer behind the window, e.g. darker so the window stands out.
  backdropStyle?: React.CSSProperties;
};

// A window over the page with a dimmed backdrop; the content draws its own header and actions.
export const Modal: React.FC<ModalProps> = ({
  onClose,
  maxWidth = ModalWidth.SM,
  surfaceStyle,
  backdropStyle,
  ...rest
}) => (
  <Dialog
    onClose={onClose ? () => onClose() : undefined}
    maxWidth={maxWidth}
    PaperProps={surfaceStyle ? { style: surfaceStyle } : undefined}
    BackdropProps={backdropStyle ? { style: backdropStyle } : undefined}
    {...rest}
  />
);
